import { defineTheme } from '../utils'

export const slaak = defineTheme({
  languageButton: {
    base: 'border-2 border-secondary bg-white/30 p-2.5 text-white',
  },
  menuCategory: {
    title: 'menuCategory-title relative z-2 mb-4 font-heading text-4xl font-semibold text-tertiary uppercase',
    description: 'menu-description relative z-2 text-white',
    base: 'border-t-2 border-secondary pt-4',
  },
  menuItem: {
    dinner: {
      base: 'dinner-base relative z-2 grid grid-cols-[1fr_auto]',
      title: 'text-lg',
      priceList: 'dinner-price text-right text-lg text-tertiary',
      description: 'dinner-description order-2 col-span-2',
      icons: 'menu-icons order-3 mt-1',
    },
    drinks: {
      base: 'dinner-base relative z-2 grid grid-cols-[1fr_auto]',
      title: 'text-lg',
      priceList: 'dinner-price text-right text-lg text-tertiary',
      description: 'dinner-description order-2 col-span-2',
      icons: 'menu-icons order-3 mt-1',
    },
  },
  menuSubCategory: {
    base: 'grid gap-4',
    title: '-mb-4 text-2xl text-secondary',
    description: '',
  },
  menuTextBlock: {
    base: '',
  },
  menuTitleBlock: {
    title: 'text-center font-heading text-6xl font-bold text-secondary',
  },
  page: {
    heading: 'font-heading text-4xl font-bold text-secondary uppercase',
    menuHeading: '',
  },
  themeLogo: {
    wrapper: 'flex h-50 w-full max-w-120',
    image: 'flex h-full w-full bg-[url(/images/logos/slaak.png)] bg-contain bg-center bg-no-repeat object-contain',
  },
  filterBar: {
    bar: 'bg-secondary text-white',
    barTitle: 'font-normal',
    checkbox: ' accent-white',
    closeButton: 'bg-primary text-white hover:bg-primary/60',
    masterItem: 'font-normal text-black',
    itemLabel: 'text-white',
    popoverTitle: 'font-normal text-white',
    popover: 'bg-primary',
    popoverHeader: 'bg-secondary',
  },
})
